export default __webpack_public_path__ + "static/media/020-Sydney Opera House.570b1075.svg";